enum IncidentTypeStatus {
  UNITARY_SIGNALING = 'UNITARY_SIGNALING',
  COLLECTIVE_SIGNALING = 'COLLECTIVE_SIGNALING',
  EXPERTISE = 'EXPERTISE',
  SIGNALING = 'SIGNALING',
  NO_STATUS = 'NO_STATUS'
}

export default IncidentTypeStatus;
